<template>
  <avs-chip
    class="min-width-120"
    color="teal"
    icon="mdi-cash-check"
    iconColor="white"
    text-color="white"
  >
    {{ $t("Payée") }}
  </avs-chip>
</template>

<script>
export default {
  name: "PaidChip",
};
</script>

<style scoped>
.min-width-120 {
  min-width: 120px;
}
</style>